import React from 'react'
import style from './card.module.css'

function Anuj() {
  return (
    <div className = {style.sumit}>
        <img src='https://edge.uacdn.net/static/thumbnail/user/eba82cb48d2c4e2eb604b2461e0f09b5.jpg?q=75&w=1000&fm=webp' alt='_Sumit_img'/>
        <div>
            <h1>Anuj Seth</h1> 
              <p>Having an experience of 13 years and have
                worked with various institutes providing
                Defense course and IIT(main and advanced)  
            </p> 
            <p>Teaches UPSC NDA and 65 more</p>  
        </div> 
    </div>
  )
}

export default Anuj;